import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteUpdateFulfilmentAgent } from "../../../data/usecases/remote-update-fulfilment-agent";
import { UpdateFulfilment } from "../../../domain/models/update-fulfilment";
import Swal from "sweetalert2";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface UpdateFulfilmentAgentInterface {
  updateFulfilmentAgent: Function;
}

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useUpdateFulfilmentAgentSlice: StateCreator<
  UpdateFulfilmentAgentInterface
> = (set, get) => ({
  updateFulfilmentAgent: async (
    payload: UpdateFulfilment,
    handleClose: Function
  ) => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteUpdateFulfilmentAgent = new RemoteUpdateFulfilmentAgent(
      `${BASE_URL}${Endpoints.UPDATE_FULFILMENT_AGENT}`,
      axiosHttpClient
    );
    let result = await remoteUpdateFulfilmentAgent.update(payload);

    if (result.success) {
      handleClose();

      Swal.fire({
        timer: 3000,
        icon: "success",
        text: "Updated Successfully",
        customClass: {
          container: "swal2-style",
        },
      });
    }
  },
});
